import script from "./MultipleSelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleSelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./MultipleSelectInput.vue?vue&type=style&index=0&id=061adab5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061adab5"]])

export default __exports__